import { motion } from "framer-motion";

const stats = [
  {
    value: "96%",
    label: "HR response within 7 days",
    tid: "stat-hr-response",
  },
  {
    value: "4.9/5",
    label: "Candidate satisfaction score",
    tid: "stat-satisfaction",
  },
  {
    value: "<5%",
    label: "Candidate acceptance rate into our cohort",
    tid: "stat-selectivity",
  },
  {
    value: "1:1",
    label: "Dedicated specialist for every candidate",
    tid: "stat-whiteglove",
  },
];

export const Stats = () => {
  return (
    <section data-testid="stats-section" className="bg-[#143628] text-[#F9F9F7]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12 py-20 sm:py-24">
        <div className="grid grid-cols-12 gap-y-10 gap-x-8 items-end mb-14">
          <div className="col-span-12 md:col-span-6">
            <p className="label-eyebrow text-[#D4B886] mb-5">By the numbers</p>
            <h2 className="font-serif-display text-4xl sm:text-5xl leading-[1.05] tracking-tight">
              Results, <em className="italic text-[#D4B886]">not promises.</em>
            </h2>
          </div>
          <p className="col-span-12 md:col-span-5 md:col-start-8 text-[#F9F9F7]/75 text-lg leading-relaxed">
            Live numbers from our experienced-tier cohort - refreshed every quarter.
            We&rsquo;d rather show the math than tell the story.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-[#F9F9F7]/10 border border-[#F9F9F7]/10">
          {stats.map((s, i) => (
            <motion.div
              key={s.tid}
              data-testid={s.tid}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
              className="bg-[#143628] p-8 sm:p-10 hover:bg-[#0D241A] transition-colors"
            >
              <p className="font-serif-display text-5xl sm:text-6xl tracking-tight leading-none">
                {s.value}
              </p>
              <p className="text-sm text-[#F9F9F7]/70 mt-4 leading-relaxed">{s.label}</p>
            </motion.div>
          ))}
        </div>

        <p className="text-xs text-[#F9F9F7]/50 mt-8 tracking-wide">
          Past performance is not a guarantee - but it&rsquo;s a strong signal.
        </p>
      </div>
    </section>
  );
};

export default Stats;
